module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Book-a8993625412334ac16da327bfe10506a.ttf";